module.exports = __webpack_public_path__ + "static/media/descarga_de_espolon.0614a67b.png";